import { Plus } from 'lucide-react';
import { useState } from 'react';

import { Button } from '../../ui/catalyst/button';
import { Dialog, DialogActions, DialogBody } from '../../ui/catalyst/dialog';
import { Text } from '../../ui/catalyst/text';
import { ThreadListProps } from './ThreadList';
import { ThreadTab } from './ThreadTab';

export const ThreadListTabs = ({
  threads,
  selectedThreadId,
  isLoading,
  onSelectThread,
  onCreateThread,
  onDeleteThread,
  onRenameThread,
}: ThreadListProps) => {
  const [threadToDelete, setThreadToDelete] = useState<string | null>(null);

  const handleDelete = () => {
    if (onDeleteThread && threadToDelete) {
      onDeleteThread(threadToDelete);
      setThreadToDelete(null);

      // If this was the selected thread, deselect it
      if (selectedThreadId === threadToDelete) {
        onSelectThread(null);
      }
    }
  };

  const handleDeleteRequest = (threadId: string) => {
    setThreadToDelete(threadId);
  };

  const renderTabs = () => {
    if (isLoading) {
      return <Text>Loading threads...</Text>;
    }

    return (
      <div className="w-full flex flex-row space-x-2 overflow-x-auto">
        {threads.map((thread) => (
          <div className="flex-shrink-0" key={thread.id}>
            <ThreadTab
              id={thread.id}
              title={thread.title}
              isSelected={selectedThreadId === thread.id}
              onSelect={onSelectThread}
              onDelete={handleDeleteRequest}
              onRename={onRenameThread}
            />
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="w-full  bg-white">
      <div className="w-full flex flex-row  items-center justify-between py-0.5 px-2">
        <div className="flex items-center justify-between relative">
          {threads.length > 0 ? (
            <div className="flex-grow overflow-x-auto pr-14">
              {renderTabs()}
            </div>
          ) : (
            <div className="flex-grow overflow-x-auto pr-14">
              <Text>No threads available</Text>
            </div>
          )}
        </div>
        <div>
          <Button onClick={onCreateThread} className="flex items-center">
            <Plus className="h-4 w-4" />
          </Button>
        </div>
      </div>

      <Dialog
        open={threadToDelete !== null}
        onClose={() => setThreadToDelete(null)}
      >
        <DialogBody>
          <div className="p-2">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Confirm deletion
            </h3>
            <p className="text-gray-600">
              Are you sure you want to delete this thread? This action cannot be
              undone.
            </p>
          </div>
        </DialogBody>
        <DialogActions>
          <Button
            onClick={() => setThreadToDelete(null)}
            outline
            className="mr-2"
          >
            Cancel
          </Button>
          <Button onClick={handleDelete} color="red">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
